import { render, staticRenderFns } from "./FAQ.vue?vue&type=template&id=420621cc&"
import script from "./FAQ.vue?vue&type=script&lang=js&"
export * from "./FAQ.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/iaai/products/maturity-assessment-tool/mat-website/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('420621cc')) {
      api.createRecord('420621cc', component.options)
    } else {
      api.reload('420621cc', component.options)
    }
    module.hot.accept("./FAQ.vue?vue&type=template&id=420621cc&", function () {
      api.rerender('420621cc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/FAQ.vue"
export default component.exports